import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import moment from 'moment';
import { Subscription as RxSubscription } from 'rxjs';
import { CsvExportService } from 'src/app/services/csv-export.service';

import { IMember } from '../../../../../../app/interfaces/member';
import { IOrganisation } from '../../../../../../app/interfaces/organisation';
import { OrganisationMemberApiService } from '../../../services/organisation-member-api-service';
import { OrganisationMemberDataSource } from '../../../services/organisation-member-data-source';
import { OrganisationsMemberOrders } from '../member-orders/component';

@Component({
  selector: 'organisation-member-list-dialog',
  templateUrl: 'component.html',
  styleUrls: ['component.scss'],
  standalone: false,
})
export class OrganisationsMemberList implements OnInit, OnDestroy {
  public loading = false;

  public displayedColumns = [
    'first_name',
    'last_name',
    'email',
    // 'branch_number',
    // 'employee_number',
    'joined',
    'expired',
  ];
  public DataSource: OrganisationMemberDataSource;
  private Subscriptions: RxSubscription[] = [];

  constructor(
    private dialog: MatDialog,
    protected OrganisationMemberApi: OrganisationMemberApiService,
    protected dialogRef: MatDialogRef<OrganisationsMemberList>,
    @Inject(MAT_DIALOG_DATA) public Organisation: IOrganisation,
  ) {}

  ngOnInit() {
    this.DataSource = this.OrganisationMemberApi.getDataSource(
      this.Organisation.company_id
        ? this.Organisation.company_id
        : this.Organisation.id,
    );
    this.Subscriptions.push(
      this.DataSource.loading.subscribe((loading) => (this.loading = loading)),
    );
    this.Subscriptions.push(
      this.DataSource.filter.subscribe(() => this.DataSource.load()),
    );

    this.DataSource.load();

    this.Organisation.slug === 'the-odney-club' &&
      this.displayedColumns.push('membership');
  }

  public setSearch(search: string) {
    this.DataSource.setFilter('search-string', search);
  }

  public downloadMembers() {
    const data = this.DataSource.connect().value;
    const filename = `${this.Organisation.slug}-members-${moment().format(
      'YYYY-MM-DD',
    )}`;
    const headers = [
      'First Name',
      'Last Name',
      'Email',
      'Branch No.',
      'Employee No.',
      'Joined',
      'Expired',
    ];

    CsvExportService.export(data as unknown as Record<string, unknown>[], filename, {
      showLabels: true,
      headers,
    });

    this.dialogRef.close();
  }

  public showMemberships(Member: IMember) {
    const config = new MatDialogConfig();
    config.data = {
      Member,
      organisationId: this.Organisation.company_id,
    };

    return this.dialog.open(OrganisationsMemberOrders, config);
  }

  ngOnDestroy() {
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }
}
